<ng-container *ngIf="data.bidNo">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="dialog-headline">
        <h2 mat-dialog-title translate>Acte de groupement </h2>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content>


        <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;" *ngIf="data.bidNo">
            <app-tree-acte-groupement-table [withcheckbok]="true" [body]="body"  (dataselected)="send($event)"></app-tree-acte-groupement-table>
        </div>
    </div>
    <div class="pc" mat-dialog-actions fxLayoutAlign="end end">
        <div fxLayout="row wrap" fxLayoutAlign="center center" >
            <button  (click)="listgroupement()" color="primary" mat-raised-button type="submit">
                {{ "consulter_groupement" | translate }}
            </button>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="center center">
            <button [disabled]="listchecked.length==0" (click)="onSuccessAdd()" color="primary" mat-raised-button type="submit">
                {{ "Rédaction" | translate }}
            </button>
        </div>


    </div>
</ng-container>


